// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// firebase deploy --only hosting:crunchandcheer-portal
export const environment = {
  production: false,
  // firebaseConfig: {
  //   apiKey: 'AIzaSyBTkbk9BGUshE0R8qpt1DHNInD6jo6GMUU',
  //   authDomain: 'nutriplanner-test.firebaseapp.com',
  //   databaseURL: 'https://nutriplanner-test.firebaseapp.com',
  //   projectId: 'nutriplanner-test',
  //   storageBucket: 'nutriplanner-test.appspot.com',
  //   messagingSenderId: '399636038554',
  //   appId: '1:399636038554:web:01320c477db56200c33023',
  //   measurementId: 'G-M6CK9NNBQF',
  // },
  firebaseConfig: {
    apiKey: 'AIzaSyCiRSTTWhTkxUvUx2i8JaE7IIv01P_agfY',
    authDomain: 'crunchandcheer-8d860.firebaseapp.com',
    projectId: 'crunchandcheer-8d860',
    storageBucket: 'crunchandcheer-8d860.appspot.com',
    messagingSenderId: '465505935782',
    appId: '1:465505935782:web:dffa1306bfb6f8bc066f67',
    measurementId: 'G-PTETEFED3K',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
